import type { IconProps } from '../types/IconProps.ts';
export const BotSmile: IconProps = {
    name: 'BotSmile',
    children: [
        `<path d="M5 9c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.04a2 2 0 0 0-1.56.75l-1.01 1.26a.5.5 0 0 1-.78 0l-1-1.26A2 2 0 0 0 9.03 19H7a2 2 0 0 1-2-2zM5 16H4a2 2 0 0 1-2-2v-2c0-1.1.9-2 2-2h1M19 16h1a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-1M12 3v4M9 3h6" />`,
        `<path d="M14.5 14.5c-.52.6-1.4 1-2.5 1q-1.79.01-2.5-1" />`,
        `<circle cx="9" cy="11" r=".5" />`,
        `<circle cx="15" cy="11" r=".5" />`,
    ]
};